import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { hasOptionalConsent, isPrivateAnalyticsPath, OPTIONAL_TRACKING_READY_EVENT } from '@/lib/analyticsConsent';

const TikTokPixel = () => {
  const location = useLocation();
  const lastTrackedPath = useRef(null);

  useEffect(() => {
    if (isPrivateAnalyticsPath(location.pathname)) {
      lastTrackedPath.current = location.pathname;
      return;
    }
    const trackPageView = () => {
      if (!hasOptionalConsent() || !window.ttq?.page || lastTrackedPath.current === location.pathname) return;
      const contentId = location.pathname === '/'
        ? 'phantompath_homepage'
        : `phantompath_${location.pathname.replace(/^\/+|\/+$/g, '').replace(/[^a-z0-9]+/gi, '_').toLowerCase() || 'page'}`;
      window.ttq.page();
      window.ttq.track?.('ViewContent', {
        content_id: contentId,
        content_ids: [contentId],
        content_name: document.title || 'PhantomPathVPN',
        content_type: 'product_group',
        content_category: location.pathname === '/' ? 'homepage' : location.pathname.replace(/^\//, ''),
      });
      lastTrackedPath.current = location.pathname;
    };
    trackPageView();
    window.addEventListener(OPTIONAL_TRACKING_READY_EVENT, trackPageView);
    return () => window.removeEventListener(OPTIONAL_TRACKING_READY_EVENT, trackPageView);
  }, [location.pathname]);

  return null;
};

export default TikTokPixel;
